function updateBundleItemActiveStates() {
  const groups = document.querySelectorAll<HTMLElement>("[data-bundle-group]");
  groups.forEach((group) => {
    const items = Array.from(
      group.querySelectorAll<HTMLElement>(".bundle-item, [data-bundle-item]"),
    );

    const checkedRadio = group.querySelector<HTMLInputElement>(
      "input[type=radio][data-variant-radio-input]:checked",
    );
    if (checkedRadio) {
      const vid = checkedRadio.value;
      items.forEach((item) => {
        const isActive = item.getAttribute("data-variant-id") === vid;
        item.classList.toggle("is-active", isActive);
      });
      return;
    }

    const labels = Array.from(
      group.querySelectorAll<HTMLLabelElement>("[data-dual-label]"),
    );
    let checkedIndex = labels.findIndex((l) =>
      l.classList.contains("is-active"),
    );
    if (checkedIndex < 0) {
      checkedIndex = labels.findIndex((label) => {
        const forId = label.getAttribute("for");
        if (!forId) return false;
        const input = document.getElementById(forId);
        return input instanceof HTMLInputElement && input.checked === true;
      });
    }
    if (checkedIndex < 0) checkedIndex = 0;
    labels.forEach((label, index) => {
      label.classList.toggle("is-active", index === checkedIndex);
    });
    items.forEach((item, index) => {
      item.classList.toggle("is-active", index === checkedIndex);
    });
  });
}

updateBundleItemActiveStates();

document.addEventListener("click", (e) => {
  if (!(e.target instanceof Element)) return;
  const label = e.target.closest("[data-dual-label]");
  if (!label) return;
  const groupCandidate = label.closest("[data-bundle-group]");
  const group = groupCandidate instanceof HTMLElement ? groupCandidate : null;
  if (group) {
    const labels = Array.from(
      group.querySelectorAll<HTMLLabelElement>("[data-dual-label]"),
    );
    const items = Array.from(
      group.querySelectorAll<HTMLElement>(".bundle-item, [data-bundle-item]"),
    );
    const variantId = label.getAttribute("data-input2-id");
    let matched = false;
    if (variantId) {
      const targetItem = group.querySelector<HTMLElement>(
        `[data-variant-id="${variantId}"]`,
      );
      if (targetItem) {
        items.forEach((it) => it.classList.remove("is-active"));
        targetItem.classList.add("is-active");
        labels.forEach((l) => l.classList.remove("is-active"));
        label.classList.add("is-active");
        matched = true;
      }
    }
    if (!matched) {
      const idx = Math.max(0, labels.findIndex((l) => l === label));
      labels.forEach((l, i) => l.classList.toggle("is-active", i === idx));
      items.forEach((it, i) => it.classList.toggle("is-active", i === idx));
    }
  }
});

document.addEventListener("change", (e) => {
  const target = e.target;
  if (!(target instanceof Element)) return;
  if (target instanceof HTMLInputElement && target.type === "radio") {
    if (
      target.closest(".variant-picker") ||
      target.hasAttribute("data-variant-radio-input")
    ) {
      updateBundleItemActiveStates();
      document.dispatchEvent(new CustomEvent("variant:change"));
    }
  }
});
